import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import type { UnresolvedQuestionItem } from '@/types/requirements_quality'

// 確認ポイントをソース種別ごとに折りたたみ表示する（requirements_quality の CategorySection と同じパターン）。
export function QuestionGroup ({
  sourceInfo,
  items,
  defaultOpen
}: {
  sourceInfo: { label: string, color: string }
  items: UnresolvedQuestionItem[]
  defaultOpen: boolean
}): React.ReactElement {
  const [open, setOpen] = useState(defaultOpen)
  const criticalCount = items.filter((q) => q.severity === 'critical').length

  return (
    <div style={{ background: 'var(--bp-surface)', border: '1px solid var(--bp-border)', borderRadius: 10, overflow: 'hidden' }}>
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '12px 16px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          textAlign: 'left',
          fontFamily: 'var(--bp-font-sans)'
        }}
      >
        <span style={{ fontSize: 13, fontWeight: 700, color: sourceInfo.color, flex: 1 }}>{sourceInfo.label}</span>
        {criticalCount > 0 && (
          <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 6px', borderRadius: 4, background: 'var(--bp-critical-pale)', color: 'var(--bp-critical)' }}>
            CRITICAL {criticalCount}
          </span>
        )}
        <span style={{ fontSize: 11, color: 'var(--bp-ink3)' }}>{items.length}件</span>
        <ChevronDown
          width={16}
          height={16}
          style={{ color: 'var(--bp-ink3)', flexShrink: 0, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .15s' }}
        />
      </button>
      {open && (
        <div className='q-list' style={{ padding: '0 16px 14px' }}>
          {items.map((q, i) => {
            const isCritical = q.severity === 'critical'
            const barColor = isCritical ? 'var(--bp-critical)' : 'var(--bp-warning)'
            return (
              <div key={i} className='q-card' style={{ borderLeft: `3px solid ${barColor}` }}>
                {(q.entity != null && q.entity !== '') && (
                  <div className='q-top'>
                    <span className='q-entity'>{q.entity}</span>
                  </div>
                )}
                {(q.reason != null && q.reason !== '') && (
                  <div className='q-failed-rules'>
                    <div className='q-rule-item'>
                      <span className='q-rule-icon'>✕</span>
                      {q.reason}
                    </div>
                  </div>
                )}
                <div className='q-hearing'>
                  <div className='q-hearing-label'>確認事項</div>
                  <div className='q-hearing-text'>{q.followup_question}</div>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
